import React, { createContext, useContext, useState, useEffect } from "react";
import api from "./axios";

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(localStorage.getItem("token") || null);
    const [loading, setLoading] = useState(true);

    // ------------------------------
    // LOGIN
    // ------------------------------
    const login = async (email, password) => {
        try {
            const res = await api.post("/api/login", { email, password });
            const newToken = res.data?.token;
            const userData = res.data?.user;

            if (!newToken) throw new Error("Aucun token retourné par /api/login");

            localStorage.setItem("token", newToken);
            setToken(newToken);
            api.defaults.headers.common["Authorization"] = `Bearer ${newToken}`;

            if (userData) {
                setUser(userData);
            } else {
                await fetchUser(newToken);
            }

            return true;
        } catch (err) {
            console.error("login error:", err);
            return false;
        }
    };

    // ------------------------------
    // REGISTER
    // ------------------------------
    const register = async (data) => {
        try {
            const res = await api.post("/api/register", data);
            return res.data;
        } catch (err) {
            console.error("Erreur d'inscription :", err);
            throw err;
        }
    };

    // ------------------------------
    // LOGOUT
    // ------------------------------
    const logout = () => {
        setUser(null);
        setToken(null);
        localStorage.removeItem("token");
        delete api.defaults.headers.common["Authorization"];
    };

    // ------------------------------
    // FETCH USER
    // ------------------------------
    const fetchUser = async () => {
        try {
            const res = await api.get("/api/me");
            setUser(res.data);
            return res.data;
        } catch (err) {
            console.error("fetchUser error", err);
            return null;
        }
    };

    // ------------------------------
    // INITIALISATION AU CHARGEMENT
    // ------------------------------
    useEffect(() => {
        let mounted = true;

        const init = async () => {
            const stored = localStorage.getItem("token");
            if (stored) {
                setToken(stored);
                api.defaults.headers.common["Authorization"] = `Bearer ${stored}`;

                // ✅ on récupère aussi l'utilisateur dès le chargement
                const current = await fetchUser(stored);
                if (mounted && current) setUser(current);
            }

            if (mounted) setLoading(false);
        };

        init();
        return () => {
            mounted = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    // ------------------------------
    // PROVIDER
    // ------------------------------
    return (
        <AuthContext.Provider value={{ user, token, loading, register, login, logout, fetchUser, isAuthenticated: !!token }}>
            {children}
        </AuthContext.Provider>
    );
};
